import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const useSelectChat = () => {
  const [isAgent, setIsAgent] = useState(false);
  const { agent } = useParams();

  useEffect(() => {
    if (agent) {
      setIsAgent(true);
    } else {
      setIsAgent(false);
    }
  }, [agent]);
  return { isAgent };
};

export default useSelectChat;
